import { useMarqueeAnimation } from '../chat/hooks/useMarqueeAnimation';

interface MarqueeTitleProps {
  title: string;
  className?: string;
  textClassName?: string;
}

const MarqueeTitle = ({ title, className = '', textClassName = '' }: MarqueeTitleProps) => {
  const { shouldAnimate, textRef, containerRef } = useMarqueeAnimation(title);
  return (
    <div
      ref={containerRef}
      className={`max-w-[175px] flex overflow-hidden ${shouldAnimate ? '' : 'justify-center'} absolute left-1/2 transform -translate-x-1/2 ${className}`}
    >
      {shouldAnimate ? (
        <div className="header-title-marquee flex w-max items-center">
          <div className="flex items-center">
            <p
              ref={textRef}
              className={`text-[17px] font-bold leading-[20px] whitespace-nowrap ${textClassName ? textClassName : 'text-main-dark-1'}`}
            >
              {title}
            </p>
            <span className="w-[16px] shrink-0" aria-hidden="true" />
          </div>
          <div className="flex items-center" aria-hidden="true">
            <p
              className={`text-[17px] font-bold leading-[20px] whitespace-nowrap ${textClassName ? textClassName : 'text-main-dark-1'}`}
            >
              {title}
            </p>
            <span className="w-[16px] shrink-0" aria-hidden="true" />
          </div>
        </div>
      ) : (
        <p
          ref={textRef}
          className={`text-[17px] font-bold leading-[20px] text-center whitespace-nowrap ${textClassName ? textClassName : 'text-main-dark-1'}`}
        >
          {title}
        </p>
      )}
    </div>
  );
};

export default MarqueeTitle;
